import { RadioGroupItem } from './RadioGroupItem';

export class RadioGroup extends PIXI.Container {
    private itemsList: RadioGroupItem[] = [];
    private currentSelected: number = -1;

    public get items() {
        return this.itemsList.slice(0);
    }

    public get selected() {
        return this.itemsList.length === 0 ? null : this.itemsList[this.currentSelected];
    }

    public set selected(value: RadioGroupItem) {
        const index = this.itemsList.indexOf(value);
        this.selectedIndex = index;
    }

    public get selectedIndex() {
        return this.currentSelected;
    }

    public set selectedIndex(value: number) {
        if (this.currentSelected === value) {
            return;
        }
        if (this.currentSelected >= 0) {
            this.selected.setSelected(false);
        }
        this.currentSelected = value;
        this.selected.setSelected(true);
        this.emit(RadioGroupEvents.SELECTION_CHANGED, this.selected);
    }

    public addItem(item: RadioGroupItem) {
        this.itemsList.push(item);
        if (this.currentSelected < 0) {
            this.selectedIndex = 0;
        }
        item.on(RadioGroupEvents.SELECTED, () => {
            this.selected = item;
        });
    }
}

export enum RadioGroupEvents {
    SELECTION_CHANGED = 'selection changed',
    SELECTED = 'item selected',
}
